function getApiBaseUrl() {
  const configured = process.env.REACT_APP_BACKEND_URL;
  if (configured) return `${configured.replace(/\/$/, '')}/api`;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/api`;
  }
  return '/api';
}

const API_BASE_URL = getApiBaseUrl();

export async function callGeminiAI(messages, systemPrompt) {
  const lastUserMessage = (messages || [])
    .slice()
    .reverse()
    .find((message) => message?.role === 'user' || message?.role === 'User')?.content
    ?.trim();

  const response = await fetch(`${API_BASE_URL}/chat`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      message: lastUserMessage || systemPrompt || 'Hello',
      session_id: 'web-chat',
    }),
  });

  let data = {};
  try {
    data = await response.json();
  } catch {
    data = {};
  }

  if (!response.ok) {
    return {
      output: null,
      error: data?.detail || data?.message || `HTTP ${response.status}`,
    };
  }

  const output = data?.message || data?.output || '';
  if (!output) {
    return { output: null, error: 'No response from backend' };
  }

  return { output, error: null };
}
